import React, { useState } from 'react';
import cx from 'classnames';
import { Collapse, List, ListItem, ListItemText } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { WithApp } from 'contexts/appContext';
import { useAuth } from 'hooks/useAuth';

const UserSide = WithApp((props) => {
  const { appContext } = props;
  const { user } = useAuth();
  const { routeState } = appContext;
  const { classes, rtlActive, bgColor, miniActive, openAvatar } = props;

  const itemText =
    classes.itemText +
    ' ' +
    cx({
      [classes.itemTextMini]: miniActive,
      [classes.itemTextMiniRTL]: miniActive && rtlActive,
      [classes.itemTextRTL]: rtlActive
    });

  const collapseItemText =
    classes.collapseItemText +
    ' ' +
    cx({
      [classes.collapseItemTextMini]: miniActive,
      [classes.collapseItemTextMiniRTL]: rtlActive && miniActive,
      [classes.collapseItemTextRTL]: rtlActive
    });
  const userWrapperClass =
    classes.user +
    ' ' +
    cx({
      [classes.whiteAfter]: bgColor === 'white'
    });
  const caret =
    classes.caret +
    ' ' +
    cx({
      [classes.caretRTL]: rtlActive
    });
  const collapseItemMini =
    classes.collapseItemMini +
    ' ' +
    cx({
      [classes.collapseItemMiniRTL]: rtlActive
    });
  const photo =
    classes.photo +
    ' ' +
    cx({
      [classes.photoRTL]: rtlActive
    });

  const [openUserMenu, setOpenUserMenu] = useState(false);

  const openCollapse = () => {
    setOpenUserMenu(!openUserMenu);
  };
  return (
    <div className={userWrapperClass}>
      <div className={photo}>
        <img src={user.avatar} className={classes.avatarImg} alt="..." />
        <h1> {user.name}</h1>
      </div>
      <List className={classes.list}>
        <ListItem className={classes.item + ' ' + classes.userItem}>
          <NavLink
            to={'#'}
            className={classes.itemLink + ' ' + classes.userCollapseButton}
            onClick={() => openCollapse()}
          >
            <ListItemText
              primary={user.name}
              secondary={
                <b
                  className={
                    caret + ' ' + classes.userCaret + ' ' + (openAvatar ? classes.caretActive : '')
                  }
                />
              }
              disableTypography={true}
              className={itemText + ' ' + classes.userItemText}
            />
          </NavLink>
          <Collapse in={openUserMenu} unmountOnExit>
            {/* <Collapse in={true} unmountOnExit> */}
            <List className={classes.list + ' ' + classes.collapseList}>
              <ListItem className={classes.collapseItem} style={{ paddingLeft: 0 }}>
                <NavLink
                  to={`/admin/perfil`}
                  className={classes.itemLink + ' ' + classes.userCollapseLinks}
                >
                  <span className={collapseItemMini}>{rtlActive ? 'مع' : 'MP'}</span>
                  <ListItemText
                    primary={rtlActive ? 'ملفي' : 'Mi Perfil'}
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
              <ListItem className={classes.collapseItem} style={{ paddingLeft: 0 }}>
                <NavLink to="#" className={classes.itemLink + ' ' + classes.userCollapseLinks}>
                  <span className={collapseItemMini}>{rtlActive ? 'هوع' : 'EP'}</span>
                  <ListItemText
                    primary={rtlActive ? 'تعديل الملف الشخصي' : 'Edit Profile'}
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
              <ListItem className={classes.collapseItem} style={{ paddingLeft: 0 }}>
                <NavLink to="#" className={classes.itemLink + ' ' + classes.userCollapseLinks}>
                  <span className={collapseItemMini}>{rtlActive ? 'و' : 'S'}</span>
                  <ListItemText
                    primary={rtlActive ? 'إعدادات' : 'Settings'}
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
              <ListItem className={classes.collapseItem} style={{ paddingLeft: 0 }}>
                <NavLink
                  to={routeState.logoutPath}
                  className={classes.itemLink + ' ' + classes.userCollapseLinks}
                >
                  <span className={collapseItemMini}>{rtlActive ? 'و' : 'S'}</span>
                  <ListItemText
                    primary={rtlActive ? 'إعدادات' : 'Cerrar sesión'}
                    disableTypography={true}
                    className={collapseItemText}
                  />
                </NavLink>
              </ListItem>
            </List>
          </Collapse>
        </ListItem>
      </List>
    </div>
  );
});

export default UserSide;
